import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import Router from 'vue-router'
import { Lazyload, Dialog } from 'vant';
import VueClipboard from 'vue-clipboard2'

Vue.use(Lazyload).use(Dialog).use(VueClipboard)
Vue.use(require('vue-wechat-title'))
Vue.use(Router)

Vue.config.productionTip = false
axios.defaults.withCredentials = true
Vue.prototype.$http = axios

const router = new Router({
  routes: [
    {
      path: '*',
      meta: {
        title: '个人中心'
      },
      component: resolve => require(['@/components/home.vue'], resolve)
    },
    {
      path: '/wallet',
      meta: {
        title: '钱包'
      },
      component: resolve => require(['@/components/wallet.vue'], resolve)
    },
    {
      path: '/team',
      meta: {
        title: '好友'
      },
      component: resolve => require(['@/components/team.vue'], resolve)
    },
    {
      path: '/orders',
      meta: {
        title: '订单'
      },
      component: resolve => require(['@/components/orders.vue'], resolve)
    },
    {
      path: '/level',
      meta: {
        title: '权益'
      },
      component: resolve => require(['@/components/level.vue'], resolve)
    },
    {
      path: '/tutor',
      meta: {
        title: '教程'
      },
      component: resolve => require(['@/components/tutor.vue'], resolve)
    },
    {
      path: '/task',
      meta: {
        title: '任务'
      },
      component: resolve => require(['@/components/task.vue'], resolve)
    },
    {
      path: '/q',
      meta: {
        title: '发现好物'
      },
      component: resolve => require(['@/components/search.vue'], resolve)
    },
    {
      path: '/share',
      meta: {
        title: '邀请好友'
      },
      component: resolve => require(['@/components/share.vue'], resolve)
    },
    {
      path: '/withdraw',
      meta: {
        title: '提现申请审核'
      },
      component: resolve => require(['@/components/withdraw.vue'], resolve)
    },
    {
      path: '/plutus',
      meta: {
        title: '貔貅特权'
      },
      component: resolve => require(['@/components/plutus.vue'], resolve)
    },
  ]
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
